import { createSelector } from 'reselect';

import { filterRequestFormatter } from 'modules/interventions/utils';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

import { CONTACT_LIST_STATUS_ENUM } from '../constants';
import { getContactListsByIds, getProps, getRoot, getUIState } from './index';

const getDashboardState = createSelector(getUIState, ui => ui.dashboard);

const getDataDashboard = createSelector(getDashboardState, state => state.data);

const getContactListsIds = createSelector(getDataDashboard, state => state.ids);

export const getContactLists = createSelector(getRoot, getContactListsIds, getContactListsByIds);

export const getPage = createSelector(getDataDashboard, state => state.page);

export const loading = createSelector(getDataDashboard, state => state.loading);

export const deleting = createSelector(getDashboardState, getProps, (state, contactListId) =>
  state.loading.delete.includes(contactListId));

export const creating = createSelector(getDashboardState, state => state.loading.create);

export const getFilters = createSelector(getDashboardState, state => state.filters);

export const getBaseRequestParams = createSelector(
  getPage,
  getSelectedDealerId,
  getFilters,
  ({ size, number }, dealerId, filters) => ({
    size,
    dealerId,
    page: number,
    status: [
      CONTACT_LIST_STATUS_ENUM.ACTIVE,
      CONTACT_LIST_STATUS_ENUM.IMPORTING
    ].join(','), // TODO: Remove `.join` after API ticket
    projection: 'page',
    ...filterRequestFormatter(filters),
  })
);

const getModalState = createSelector(getDashboardState, dashboard => dashboard.modal);

export const isCreationModalOpen = createSelector(getModalState, modal => modal.creation);
